import {SelectItem} from 'primeng/api';

export class HealthTasks {
  id?: number;
  title: string;
  unit?: string;
  possibleValues?: string;
  valuesArray?: SelectItem[];
  taskType: string;
  status?: boolean;
  quantity?: SelectItem;
}
